import { render, staticRenderFns } from "./CustomerImagePreview.vue?vue&type=template&id=31156645&scoped=true&"
import script from "./CustomerImagePreview.vue?vue&type=script&lang=js&"
export * from "./CustomerImagePreview.vue?vue&type=script&lang=js&"
import style0 from "./CustomerImagePreview.vue?vue&type=style&index=0&id=31156645&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31156645",
  null
  
)

export default component.exports